import {Typography} from "@mui/material";
import {DataTableCellProps} from "@variocube/app-ui";
import React from "react";
import {BookingShare} from "../../../api";

export function BookingShareEmailsCell({row}: Readonly<DataTableCellProps<BookingShare>>) {
	if (!row.emails || row.emails.length === 0) {
		return <Typography>-</Typography>;
	}

	return (
		<>
			{row.emails.map((email) => (
				<Typography key={email} display="block">
					{email}
				</Typography>
			))}
		</>
	);
}
